import React from 'react';
import { motion } from 'framer-motion';
import '../../styles/industries.css';
import aiImg from '../../assets/artificial-intelligence.jpg';

const ArtificialIntelligence = () => (
  <div
    className="industry-page"
    style={{ backgroundImage: `url(${aiImg})` }}
  >
    <motion.div
      className="industry-content"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1>Artificial Intelligence</h1>
      <p>
        Delivering smart, AI-driven systems that automate, optimize, and elevate business decisions and user experiences.
      </p>
      <ul className="bullet-points">
        <li>🔍 OCR & document processing.</li>
        <li>👁️ Fraud detection models.</li>
        <li>🧠 Chatbots & language models.</li>
        <li>⚙️ Predictive & prescriptive analytics.</li>
        <li>🤖 Robotic Process Automation. </li>
        <li>🔄 Workflow Automation</li>
      </ul>
    </motion.div>
  </div>
);

export default ArtificialIntelligence;
